<app-app-nav></app-app-nav>
<main id="mainContent" tabindex="-1">
    <app-whatsapp></app-whatsapp>

    <div class="container-fluid">
        <div class="row bg-secondary py-4">
            <div class="col">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb animate__animated animate__fadeInDown mb-0">
                  <li class="breadcrumb-item mb-2 mb-md-0">
                    <a class="text-white">أكادميه الفنون</a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    بوابة اعضاء ﻫﻴﺌﺔ اﻟﺘﺪرﻳﺲ
                  </li>
                </ol>
              </nav>
            </div>
          </div>

          <div class="mt-3 container-fluid floated-contatiner-top position-relative">
            <div class="row">
                <div class="col-lg-11 offset-lg-1 bg-white">
                    <ul class="col-lg-11 ps-3">
                        <section class="pt-4 mt-3">
                            <h1
                                class="heading-font fs-1 heading-style mb-4 fw-normal animate__animated animate__fadeInUp animate__faster wow">
                                أعضاء هيئة التدريس
                            </h1>
                            <div class="d-flex table-responsive pb-3  bg-white alphabit alphabit-nav" id="alphabit-nav"
                                aria-label="alphabit navigation" data-type="nav">
                                <div *ngFor="let item of facultyTechGroup ; let i = index"
                                    class="px-3 flex-md-fill rounded-circle">
                                    <a class="pt-2 text-secondary fw-bold d-block" (click)="scroolDowen(i)" role="button" tabindex="0" (keydown.enter)="scroolDowen(i)" (keydown.space)="scroolDowen(i)">
                                        {{item.letter}}
                                    </a>
                                </div>
                            </div>
                            <div data-bs-spy="scroll" data-bs-target="#alphabit-nav" data-bs-offset="30"
                                class="scrollspy-example" tabindex="0">
                                <div class="row" data-type="list">
                                    <div class="col-lg-4 col-md-6 d-flex" *ngFor="let tech of facultyMainTech">
                                        <a (click)="openProfile(tech.id)" style="cursor: pointer"
                                            class="d-flex w-100 border-bottom py-3 px-2 align-items-center doc-list-element"
                                            aria-label="انقر لعرض الملف الشخصي للمدرب" role="button" tabindex="0" (keydown.enter)="openProfile(tech.id)" (keydown.space)="openProfile(tech.id)">
                                            <div class="inst-img overflow-hidden rounded-circle">
                                                <img [src]="tech.image ? tech.image : 'assets/img/instructor-default.png'" style="width: 100px" alt="" />
                                            </div>
                                            <div class="inst-info ps-3">
                                                <h6 class="mb-1 text-black">
                                                    {{tech.name}}
                                                </h6>
                                                <div class="small text-gray">
                                                    {{tech.scientificdegree}}
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div [id]="i" *ngFor="let item of facultyTechGroup; let i = index">
                                    <div class="text-secondary fs-6 fw-bold alphabit-sec-header position-relative">
                                        <span class="d-inline-block p-2 bg-white"> {{item.letter}}</span>
                                    </div>
                                    <div class="row" data-type="list">
                                        <div class="col-lg-4 col-md-6 d-flex" *ngFor="let tech of item.teachingmembers">
                                            <a (click)="openProfile(tech.id)" style="cursor: pointer"
                                                class="d-flex w-100 border-bottom py-3 px-2 align-items-center doc-list-element"
                                                aria-label="انقر لعرض الملف الشخصي للمدرب" role="button" tabindex="0" (keydown.enter)="openProfile(tech.id)" (keydown.space)="openProfile(tech.id)">
                                                <div class="inst-img overflow-hidden rounded-circle">
                                                    <img [src]="tech.image ? tech.image : 'assets/img/instructor-default.png'" style="width: 100px" alt="" />
                                                </div>
                                                <div class="inst-info ps-3">
                                                    <h6 class="mb-1 text-black">
                                                        {{tech.name}}
                                                    </h6>
                                                    <div class="small text-gray">
                                                        {{tech.scientificdegree}}
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                    </ul>
                </div>
            </div>
        </div>
        </div>
</main>
